<ng-container *ngIf="historyItem && historyItem.record">
  <app-card-item
    [baseData]="baseData"
    [percentage]="historyItem?.percentage"
    [detailsLeft]="detailsLeft"
    [detailsRight]="detailsRight"
    (actionNavigate)="openItemDetail()">
    <ng-template appButtonPanel>
      <app-rating class="interactions__rating" [record]="historyItem?.record"></app-rating>
      <app-favorite-button [recordId]="historyItem?.recordId"></app-favorite-button>
      <app-more-option-button
        [recordItem]="historyItem?.record"
        [historyItem]="historyItem"
        [isHistoryItem]="true"
        [certificateSection]="true"
        (removed)="onRemoved($event)">
      </app-more-option-button>
    </ng-template>
    <ng-template appRecordButtons>
      <app-record-buttons
        *ngIf="showRecordButtons"
        [class.app-record-buttons-inactive]="!historyItem?.record?.active"
        from="USER_SCREENS"
        [record]="historyItem?.record"
        [config]="config"
        [historyItem]="historyItem"
        [physicalRecord]="physicalRecord"
        [certificateSection]="true">
      </app-record-buttons>
    </ng-template>
  </app-card-item>
</ng-container>
